import type { MapCloudPoint, MapPointCloudAccuracyRingsMode, MapPointCloudSetOptions } from '@gpx-spa/geo-domain'
import { positiveAccuracyRadiusMeters } from './accuracy-ring-pixels.js'
import { cloudPointPositionKey } from './map-point-cloud-to-geojson.js'

export function accuracyRingsMode(
  options: MapPointCloudSetOptions | undefined,
): MapPointCloudAccuracyRingsMode {
  return options?.accuracyRings ?? 'none'
}

/** Visible points that should receive an accuracy ring for the current mode. */
export function pointsForAccuracyRings(
  visible: readonly MapCloudPoint[],
  mode: MapPointCloudAccuracyRingsMode,
  selectedPositionKey: string | null,
): MapCloudPoint[] {
  if (mode === 'none') return []
  const positive = visible.filter(
    (point) => positiveAccuracyRadiusMeters(point.accuracyRadiusMeters) != null,
  )
  if (mode === 'all') return positive
  if (!selectedPositionKey) return []
  return positive.filter((point) => cloudPointPositionKey(point.position) === selectedPositionKey)
}
